import { Component, Input } from '@angular/core';
import { getUniqueSellingPointList } from '@app/sales/modules/subscription/constants/value-added-service-product';

@Component({
  selector: 'app-unique-selling-points',
  templateUrl: './unique-selling-points.component.html',
  styleUrls: ['unique-selling-points.component.scss'],
  standalone: true,
})
export class UniqueSellingPointsComponent {
  @Input() VASProductName: string;

  get uniqueSellingPoints() {
    return getUniqueSellingPointList(this.VASProductName);
  }
}
